import { useCallback, useMemo } from 'react'
import { useParams } from 'react-router-dom'

import {
  useGetCannedJobExpandedQuery,
  useUpdateCannedJobMutation
} from '../../redux/api/cannedJobApi'
import useAccessTokenAndShopId from '../useAccessTokenAndShopId/useAccessTokenAndShopId'

export const useUpdateCannedJobDate = () => {
  const { id } = useParams()
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const [updateCannedJob] = useUpdateCannedJobMutation()
  const { data: cannedJobs } = useGetCannedJobExpandedQuery(
    {
      authorization: accessToken,
      shop: shopId,
      cannedJobs: [id!]
    },
    { skip: !id }
  )
  const cannedJob = useMemo(
    () => (cannedJobs ? cannedJobs[0] : undefined),
    [cannedJobs]
  )
  const updateDate = useCallback(() => {
    if (!cannedJob) {
      return
    }
    updateCannedJob({
      authorization: accessToken,
      cannedJobEntry: {
        id: cannedJob.entry!.id!,
        info: {
          ...cannedJob.entry!.info!,
          lastUpdated: new Date()
        }
      }
    })
  }, [accessToken, cannedJob, updateCannedJob])
  return { cannedJob, updateDate }
}
